//账号停用提示界面

require("clover/panel/component/common/UIGroupButton")

let AccountStopUseTipPanel = xClass("AccountStopUseTipPanel", BasePanel, function () {
    let __VA_ARG = $slice(arguments, 0)
    // WARN: maybe multi result
    return cc.Node.create()
})
let RES = table(
    "packed/logout.pack"
)
AccountStopUseTipPanel.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask)
}
AccountStopUseTipPanel.preloadResPromise = function(useMask = false) {
    return preloadWithLoadingPromise(RES, useMask)
}
let _instance = null
AccountStopUseTipPanel.getInstance = function () {
    let self = this
    return _instance
}
AccountStopUseTipPanel.prototype.ctor = function (data) {
    let self = this
    // super 
    // BasePanel.ctor(self)
    BasePanel.prototype.ctor.call(self);
    _instance = self
    self.aManager = AccountManager.getInstance()
    self.aManager.dcStopUserTipPanelOpen()
    self.initUI();
}
AccountStopUseTipPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this
    // BasePanel.onClose(self, callback)
    BasePanel.prototype.onClose.call(self, callback, arg, withoutAnim);

}
AccountStopUseTipPanel.prototype.onCleanup = function () {
    let self = this
    // ref 
    _instance = null
    beforeClose(self);
    ResManager.release(RES);
    // FrameLoader.unloadImageWithPlists(RES, true)
    // cc.Director.getInstance().getTextureCache().removeUnusedTextures()
}
/**
 * 关闭前的操作
 * 关闭一些动画、定时操作
 * @param {*} self 
 */
function beforeClose(self) {}


AccountStopUseTipPanel.prototype.initUI = function () {
    let self = this
    self.mainNode = cc.CSLoader.createNode("cocos/logout_logout_disable.csb")
    self.addChild(self.mainNode);

    this.btnClose = self.mainNode.getChildByName("close");
    quickBuildBtn(this.btnClose, UIGroupButton, PushBounceAnim, () => {
        this.onClose();
        if (window.mini){
            mini.exitMiniProgram({})
        }
        SnsProxy.getInstance().popBack()
    }, true);


    this.btnConfirm = self.mainNode.getChildByName("button");
    quickBuildBtn(this.btnConfirm, UIGroupButton, PushBounceAnim, () => {
        // self.aManager.showProposePanel()
        this.onClose();
        if (window.mini){
            mini.exitMiniProgram({})
        }
        SnsProxy.getInstance().popBack()
    }, true);
    this.btnConfirm.y = -165

    self.mainNode.getChildByName("lable1").setVisible(false)
    self.mainNode.getChildByName("lable2").setVisible(false)

    this.mainNode.getChildByName("tittle_lab").setString("账号已停用")

    // let txtString = "您的消消乐账号：玩家消消乐{id}\n该账号在{c=155,91,63,255/c}{date}{c=215,42,31,255/c}申请了账号删除，我们将于申请日期{delete_date}天后正式删除该账号。若您希望重新找回账号，请{c=155,91,63,255/c}在账号删除前{c=215,42,31,255/c}重新登录游戏{c=155,91,63,255/c}进行账号恢复，超时{c=215,42,31,255/c}账号被删除{c=155,91,63,255/c}将无法找回{c=215,42,31,255/c}"
    let txtString = getText("delete.page5.text")
    // let txtString = "您的消消乐账号：{id}\n    该账号在{c=155,91,63,255/c}{date}{c=215,42,31,255/c}申请了账号删除，我们将于申请日期{delete_date}天后正式删除该账号。\n    若您希望重新找回账号，请{c=155,91,63,255/c}在账号删除前{c=215,42,31,255/c}重新登录游戏{c=155,91,63,255/c}进行账号恢复{c=215,42,31,255/c}，{c=155,91,63,255/c}超时{c=215,42,31,255/c}账号被删除{c=155,91,63,255/c}将无法找回{c=215,42,31,255/c}" 

    let profile = UserManager.getInstance().profile
    txtString = txtString.replace("{id}", profile.uid);//name
    let delete_date = MetaManager.getDeleteAccountConfig().delete_date || 7
    txtString = txtString.replace("{delete_date}", delete_date);
    let localDate = new Date(Localhost.time())

    let dateStr= formatDate(localDate, 'yyyy年MM月dd日HH时mm分ss秒')
    txtString = txtString.replace("{date}", dateStr);


    // xxxx年xx月xx日xx时xx分xx秒
    
    // let txtString = "亲爱的小村民，您正在进行{c=155,91,63,255/c}账号删除{c=215,42,31,255/c}操作，继续将会导致：\n1.您的{c=155,91,63,255/c}风车币，道具{c=215,42,31,255/c}等物品将会删除  {c=155,91,63,255/c}"
    let colorLabel= getColorTextH5(txtString,21,22)
    colorLabel.x = -colorLabel.width/2
    // colorLabel.y = -colorLabel.height/2
    colorLabel.y = 90

    // colorLabel.x = -110
    this.mainNode.addChild(colorLabel)


}
module.exports = AccountStopUseTipPanel